import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { RewardsBrand, Tier } from '@ps/web-core-enums';

import { select } from '../../../index';
import type { Model, RootState, SelectorCreator, Slicer } from '../../types';
import type { CvlBar, CvlConfig, RewardsStateModel } from '../../types/Rewards';

export interface RewardsState {
  data?: RewardsStateModel;
  subscriptions: { [path: string]: string };
  oldPoints: number;
}

export const defaultCvlBar: CvlBar = {
  boostRemaining: 0,
  chestsCount: 0,
  currentPoints: 0,
  excludedFromSR: false,
  excludedUser: false,
  goingToTierDown: false,
  goingToTierUp: false,
  hideChests: false,
  nextBoostTimeHours: 0,
  nextBoostTimeMinutes: 0,
  optinNotificationActive: false,
  showTierUp: false,
  starCoinBalance: 0,
  targetPoints: 0,
  tierId: Tier.Blue,
  tierUpEndHours: 0,
  tierUpEndMinutes: 0,
  userExcluded: false,
  userOptedIn: false
};

export const defaultCvlConfig: CvlConfig = {
  boostEnabled: false,
  canExchange: false,
  cvl2: true,
  daysToExpire: 0,
  exchangePercent: 0,
  expiresOn: '',
  goingToTierDown: false,
  goingToTierUp: false,
  recentBarCounter: 0,
  showTierDownExchange: false,
  showTierDownPopUp: false,
  showTierUpPopUp: false,
  startedOn: '',
  tierDownDays: 0,
  tierUpBars: 0,
  tierUpDays: 0,
  timezone: '',
  totalDoneBarCount: 0,
  chestHistory: []
};

export const defaultState = {
  subscriptions: {},
  oldPoints: 0
};

const reducers = {
  set: (state: RewardsState, payload: RewardsState) => ({ ...state, ...payload }),
  'session/clear': (): RewardsState => defaultState
};

const selectors = (slice: Slicer<RewardsState>, createSelector: SelectorCreator) => ({
  get() {
    return slice((state) => state || {});
  },
  getCvlBarData() {
    return slice((state) => state.data?.cvlBar || defaultCvlBar);
  },
  getCvlConfigData() {
    return slice((state) => state.data?.cvlConfig || defaultCvlConfig);
  },
  getRewardsBrand() {
    return createSelector(
      (rootState: RootState) => select.cms.getBrandId(rootState),
      (brand) => {
        switch (brand) {
          case BrandTypes.FOX_BET:
            return RewardsBrand.FoxBet;
          default:
            return RewardsBrand.PokerStars;
        }
      }
    );
  },
  isExcluded() {
    return slice(({ data }) => data?.cvlBar?.excludedFromSR || data?.cvlBar?.userExcluded);
  }
});

const rewards: Model<RewardsState, typeof reducers, void, void, typeof selectors> = {
  state: defaultState,
  reducers,
  selectors
};

export default rewards;
